import api from './api';

export const getSolicitacaoConsulta = async () => {
  try {
    const { data } = await api.get(
      '/SolicitacaoConsulta/PendentesAtendimentoInterno'
    );
    return { data };
  } catch (error) {
    return { error };
  }
};

export const getAtendimentosOperador = async params => {
  const { yesterday, today } = params;
  const remaining = `DataInicio=${`${yesterday}`}&DataFim=${`${today}`}`;
  try {
    const { data } = await api.get(
      `/Atendimento/AtendimentosInternos?${remaining}`
    );
    return { data };
  } catch (error) {
    return { error };
  }
};

export const putFinalizarAtendimento = async params => {
  try {
    await api.put('/Atendimento/Encerrar', params);
  } catch (error) {
    return { error };
  }
};

export const patchPriorizarConsulta = async idSolicitacao => {
  try {
    const { status } = await api.patch(
      `/SolicitacaoConsulta/Priorizar/${idSolicitacao}`
    );
    return { status };
  } catch (error) {
    return { error };
  }
};

export const getIndicadores = async () => {
  try {
    const { data } = await api.get('/Indicadores');
    return { data };
  } catch (error) {
    return { error };
  }
};

export const getStatusAtendimento = async () => {
  try {
    const { data } = await api.get('/Usuario/StatusAtendimento');
    return { data };
  } catch (error) {
    return { error };
  }
};
